var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{style:(("height: " + _vm.height + "px;")),attrs:{"src":"/goguest-logo.png"}})}
var staticRenderFns = []

export { render, staticRenderFns }